const endpoint = 'checkout';

export default ['api', function (api) {
    return {
        submitBasket: basket => {
            return api.post(endpoint, basket).then(response => response.data);
        },
        retrieveBasket: (basketCode, items = null) => {
            return api.get(`${endpoint}/basket/${basketCode}` + (items ? '?items=true' : '')).then(response => response.data);
        },
        generateBasket: () => {
            return api.post(`${endpoint}/basket`, {}).then(response => response.data);
        },
        deleteBasket: (basketCode) => {
            return api.delete(`${endpoint}/basket/${basketCode}`).then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/services/api.basket.service.js